export class SearchList {
    custId: string;
    quotationId: string;
    custName: string;
    quotationStatus: string;
    phoneNum: string;
    nextPage: string;
    exShowRoom: string;
    modelName: string;
    variant: string;
    brandName: string;
    quotStatusId: number;
    reviewDto: any;
    asset: string;
    indusRefId: string;
    applicationNo: string;
    applicationStatus: string;
    show: boolean;
    brandId: string;
    occupationTypcode: string;
    appType: string;
}
